export const linkedInScript = `
_linkedin_partner_id = '4607929';
window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
window._linkedin_data_partner_ids.push(_linkedin_partner_id);
`;
